import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addFilter,
  filter,
  deleteFilter,
  getProductsNextPage,
  filterAndKeepAll,
  clearAllFilters,
} from "../actions/products-actions/actions";
import { Filter } from "../components/Filter/Filter";
import { StandardDraggableProductCard } from "../components/ProductCard/StandardDraggableProductCard";
import { Link } from "react-router-dom";
import { handleLeftDrawer, handleBottomDrawer } from "../actions/actionCreators";
import { Drawer, Card, message, Input, Divider, Button, Modal, Tooltip } from "antd";
import Select from "antd/lib/select";
import { useParams, useLocation } from "react-router-dom";
import ReactSelect from "react-select";
import { getCollaborators } from "../actions/order-actions/actions";
import "../sass/ProductsPage.scss";
import { Spinner } from "../components/Spinner";
import backArrow from "../img/backArrow.png";
import { history } from "../index";
import { Droppable, DragDropContext } from "react-beautiful-dnd";
import { addProducttoFolder, createFolder } from "../actions/folders-actions/actions";
import { FilterOutlined, ClearOutlined, PlusOutlined } from "@ant-design/icons";
import Head from "../components/Head";
import ExampleProductCard from "../components/ProductCard/ExampleProductCard";
import placeholder_jeans from "../img/placeholder_jeans.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import axios from "axios";
import axiosInstance from "../config/axios-instance";
import ProductServices from "../actions/products-actions/services";
import { v4 as uuidv4 } from "uuid";
import no_result from "../img/no_result.png";
import DenimProduct from "../components/ProductDetails/DenimProduct";
import KnitProduct from "../components/ProductDetails/KnitProduct";
import MixProduct from "../components/ProductDetails/MixProduct";
import BottomDrawer from "../components/BottomDrawer/BottomDrawer";
import Folder from "../components/Folder/Folder";
import PlusIcon from "../icons/PlusIcon";
import { clearfolderToMoveTo } from "../actions/folders-actions/actions";
import "../components/AddToCollection/AddToCollection.scss";
import { Button as DemcoButton } from "../components/Button/Button";

interface Props {}
const { Meta } = Card;

export const Products = (props: Props) => {
  const location = useLocation();
  const params: any = useParams();
  const { user } = useSelector((state: any) => state.auth);
  const folders = useSelector((state: any) => state.folders);
  const [min_price_allowed, setMin_price_allowed] = useState(1);
  const [max_price_allowed, setMax_price_allowed] = useState(1000);
  
  const dispatch = useDispatch();

  const [quickViewProduct, setQuickViewProduct] = useState<any>(null);
  const [quickViewVisible, setQuickViewVisible] = useState(false);
  const [showCollectionForm, setShowCollectionForm] = useState(false);

  const [folderData, setFolderData] = useState({
    name: "",
    description: "",
    collaborator: [],
    season: '',
    year: ""
  });

  const { collaborators } = useSelector((state: any) => state.orders);

  const customStylesCreateMark = {
    control: (base: any) => ({
      ...base,
      border: 0,
      borderBottom: "1px solid #ccc",
      borderRadius: 0,
      padding: 0,
      boxShadow: "none",
      "&:hover": {
        outline: "none",
      },
    }),
    valueContainer: (base: any) => ({
      ...base,
      paddingLeft: 0,
    }),
  };

  const customStylesCreateModern = {
    control: (base: any, state: any) => ({
      ...base,
      background: "white",
      borderColor: state.isFocused ? "#00468c" : "#e2e8f0",
      borderRadius: "8px",
      padding: "2px",
      fontSize: "14px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#00468c",
      },
    }),
    placeholder: (base: any) => ({
      ...base,
      color: "#94a3b8",
    }),
    menu: (base: any) => ({
      ...base,
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e2e8f0",
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? "#00468c" : state.isFocused ? "#f1f5f9" : "white",
      color: state.isSelected ? "white" : "#1e293b",
      padding: "10px 12px",
      fontSize: "14px",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#00468c",
      },
    }),
  };

  const currentYear = new Date().getFullYear();
  const options_year = [
    { value: String(currentYear).slice(2), label: String(currentYear) },
    { value: String(currentYear + 1).slice(2), label: String(currentYear + 1) },
    { value: String(currentYear + 2).slice(2), label: String(currentYear + 2) },
    { value: String(currentYear + 3).slice(2), label: String(currentYear + 3) },
    { value: String(currentYear + 4).slice(2), label: String(currentYear + 4) },
  ];

  const options_season = [
    { value: 'ps', label: 'PS' },
    { value: 'ss', label: 'SS' },
    { value: 'pf', label: 'PF' },
    { value: 'fw', label: 'FW' }
  ];

  const handleCreateNewFolder = () => {
    if (!folderData.name) {
      message.error("Please specify the collection name!");
      return;
    }
    dispatch(createFolder({ ...folderData, product_id: quickViewProduct?.id }));
    setShowCollectionForm(false);
    setFolderData({ name: "", description: "", collaborator: [], season: '', year: "" });
    message.success("Collection created successfully");
  };

  useEffect(() => {
    dispatch(getCollaborators(""));
  }, [dispatch]);

  const openQuickView = async (product: any) => {
    setQuickViewProduct(product);
    setQuickViewVisible(true);
    try {
        const res = await ProductServices.getOneProduct(product.id);
        if (res.data) {
             setQuickViewProduct(res.data);
        }
    } catch (e) {
        console.log(e);
    }
  };

  const [min_price, setMin_price] = useState(1);
  const [max_price, setMax_price] = useState(1000);
  const [min_priceBefore, setMin_priceBefore] = useState(1);
  const [max_priceBefore, setMax_priceBefore] = useState(1000);
  const [min_elasticity, setMin_elasticity] = useState(1);
  const [max_elasticity, setMax_elasticity] = useState(1000);
  const [min_elasticity_before, setMin_elasticity_before] = useState(1);
  const [max_elasticity_before, setMax_elasticity_before] = useState(1000);
  const [min_elasticity_allowed, setMin_elasticity_allowed] = useState(1);
  const [max_elasticity_allowed, setMax_elasticity_allowed] = useState(1000);

  const [min_weight, setMin_weight] = useState(1);
  const [max_weight, setMax_weight] = useState(1000);
  const [min_weight_before, setMin_weight_before] = useState(1);
  const [max_weight_before, setMax_weight_before] = useState(1000);
  const [min_weight_allowed, setMin_weight_allowed] = useState(1);
  const [max_weight_allowed, setMax_weight_allowed] = useState(1000);
  const [forYouCompany, setForYouCompany] = useState<any>(null);

  const [count, setcount] = useState(0);
  const [queries, setQueries] = useState<Array<string>>([
    `fabric_types=${params.fabric}`,
    `categories=${params.categoryId}`,
    `genders=${params.genderId}`,
  ]);
  const [width, setWidth] = useState(window.innerWidth);
  const [openFilterDrawer, setOpenFilterDrawer] = useState(false);
  const [url, setUrl] = useState(
    `/products?fabric_types=${params.fabric}&categories=${params.categoryId}&genders=${params.genderId}`
  );

  const [hasMore, sethasMore] = useState(true);

  const [page, setpage] = useState(1);



  const {
    products,
    productsAll,
    isLoading,
    next_page,
    filters,
    isLoadingNext,
    prices,
    elasticity_fabric,
    weight_fabric,
  } = useSelector((state: any) => state.products);
  const [company, setCompanies] = useState<any>(null);
  const [clients, setClients] = useState<any>(null);
  const getCompanies = async () => {
    const company_id = localStorage.getItem("company_id");
    let token = localStorage.getItem("token");

    await axiosInstance({
      method: "get",
      url: `/admin/companies`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(function (response) {
      setCompanies(response.data);
    });
    return "ok";
  };
  const getClients = async () => {
    let token = localStorage.getItem("token");

    await axiosInstance({
      method: "get",
      url: `/clients/for_you`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(function (response) {
      setClients(response.data);
    });
    return "ok";
  };
  const getForYouCompany = async (company_id: string) => {
    let token = localStorage.getItem("token");
    if (company_id) {
      await axiosInstance({
        method: "get",
        url: `/admin/forYouCompany/${company_id}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(function (response) {
        setForYouCompany(response.data);
      });
      return "ok";
    }
  };

  const onDragEnd = React.useCallback((draggable: any) => {
    const { destination, draggableId } = draggable;

    if (draggableId) {
      if (draggableId.includes("draggable-product")) {
        const productData = JSON.parse(draggableId);

        const productId = productData.draggableId.substring(
          "draggable-product".length
        );
        const currentproductParentId = productData.parentId;
        if (destination && destination.droppableId) {
          if (destination.droppableId.includes("droppable-minature")) {
            const newParentIdDroppable = destination.droppableId.substring(
              "droppable-minature".length
            );
            if (newParentIdDroppable !== currentproductParentId) {
              dispatch(addProducttoFolder(newParentIdDroppable, productId));
              setIsDragging(false);
            }
          }
        }
      }
    }
    setIsDragging(false);
    // eslint-disable-next-line
  }, []);
  const [isDragging, setIsDragging] = useState<boolean>(false);

  const onDragStart = () => {
    setIsDragging(true);
  };

  useEffect(() => {
    // Initialize data and fetch companies/clients only once
    const initializeData = async () => {
      const company_id = localStorage.getItem("company_id");
      if (company_id) {
        await Promise.all([
          getCompanies(),
          getClients(),
          getForYouCompany(company_id),
        ]);
      }
    };

    initializeData();
  }, []);

  useEffect(() => {
    // Reset queries when location changes
    const newQueries = [
      `fabric_types=${params.fabric}`,
      `categories=${params.categoryId}`,
      `genders=${params.genderId}`,
    ];
    setQueries(newQueries);

    // Single API call to get initial products and filters
    dispatch(filterAndKeepAll(`/products?${newQueries.join("&")}`));
  }, [location.pathname]);


  
  useEffect(() => {
    // Only update URL and fetch products when filters actually change
    if (count > 1) {
      // Skip initial render
      const newUrl =
        params.fabric === "denim"
          ? `/products?${queries.join(
              "&"
            )}&min_price=${min_price}&max_price=${max_price}&elasticity_min=${min_elasticity}&elasticity_max=${max_elasticity}&weight_min=${min_weight}&weight_max=${max_weight}`
          : `/products?${queries.join(
              "&"
            )}&min_price=${min_price}&max_price=${max_price}`;

      setUrl(newUrl);
      dispatch(filter(newUrl));
      dispatch(addFilter(queries));
    }
    setcount(count + 1);
  }, [
    min_price,
    max_price,
    min_elasticity,
    max_elasticity,
    min_weight,
    max_weight,
    queries,
  ]);

  useEffect(() => {
    let resize = () =>
      window.addEventListener("resize", () => {
        setWidth(window.innerWidth);
      });
    resize();
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  useEffect(() => {
    if (productsAll.length) {
      // let total_prices = productsAll
      //   .filter((product: any) => product.fabric_type === params.fabric)
      //   .map((el: any) => el.total_price);
      // let maxPrice = Math.max(...total_prices);
      // let minPrice = Math.min(...total_prices);
      setMax_price(prices.max_price);
      setMin_price(prices.min_price);
      setMax_price_allowed(prices.max_price);
      setMin_price_allowed(prices.min_price);
      setMin_priceBefore(prices.min_price);
      setMax_priceBefore(prices.max_price);
      setMin_elasticity(elasticity_fabric?.min_elasticity_value);
      setMax_elasticity(elasticity_fabric?.max_elasticity_value);
      setMin_elasticity_before(elasticity_fabric?.min_elasticity_value);
      setMax_elasticity_before(elasticity_fabric.max_elasticity_value);
      setMax_elasticity_allowed(elasticity_fabric?.max_elasticity_value);
      setMin_elasticity_allowed(elasticity_fabric?.min_elasticity_value);

      setMin_weight(weight_fabric?.min_weight_value);
      setMax_weight(weight_fabric?.max_weight_value);
      setMin_weight_before(weight_fabric?.min_weight_value);
      setMax_weight_before(weight_fabric?.max_weight_value);
      setMax_weight_allowed(weight_fabric?.max_weight_value);
      setMin_weight_allowed(weight_fabric?.min_weight_value);

      // if (total_prices.length === 0) {
      //   setMax_price(0);
      //   setMin_price(0);
      //   setMax_price_allowed(0);
      //   setMin_price_allowed(0);
      // }
    }
    // eslint-disable-next-line
  }, [productsAll]);

  const handleChangePrice = (val: any) => {
    let [min, max] = val;
    setMin_price(min);
    setMax_price(max);
  };

  const handleChangePriceAfter = (val: any) => {
    let [min, max] = val;
    setMin_priceBefore(min);
    setMax_priceBefore(max);
  };

  const handleChangeElasticity = (val: any) => {
    let [min, max] = val;
    setMin_elasticity(min);
    setMax_elasticity(max);
  };

  const handleChangeWeight = (val: any) => {
    let [min, max] = val;
    setMin_weight(min);
    setMax_weight(max);
  };

  const addQuery = (target: any) => {
    const element = target.name + "=" + target.id;
    if (target.checked) {
      var exists = queries.filter((query: any) => query.includes(target.name));
      if (exists.length === 0) {
        setQueries([...queries, element]);
      } else {
        var newQueryVal = exists[0].concat("," + target.id);
        setQueries(
          queries.map((el: any) =>
            el.includes(target.name) ? newQueryVal : el
          )
        );
      }
    } else if (!target.checked) {
      var exist = queries.filter((query: any) =>
        query.includes(target.name)
      )[0];
      if (exist.includes(",") === false) {
        setQueries(queries.filter((el) => !el.includes(target.name)));
      } else if (
        exist.indexOf(target.id) ===
        exist.length - target.id.toString().length
      ) {
        let newQuery = exist.substr(
          0,
          exist.length - (target.id.toString().length + 1)
        );
        setQueries(
          queries.map((el: any) => (el.includes(target.name) ? newQuery : el))
        );
      } else {
        let newQuery = exist.replace(target.id + ",", "");
        setQueries(
          queries.map((el: any) => (el.includes(target.name) ? newQuery : el))
        );
      }
    }
  };

  const deleteFilterTag = (obj: any) => {
    var exist = queries.filter((query: any) =>
      query.includes(obj.filteredBy)
    )[0];
    if (exist.includes(",") === false) {
      setQueries(queries.filter((el) => !el.includes(obj.filteredBy)));
    } else if (
      exist.indexOf(obj.id) ===
      exist.length - obj.id.toString().length
    ) {
      let newQuery = exist.substr(
        0,
        exist.length - (obj.id.toString().length + 1)
      );
      setQueries(
        queries.map((el: any) => (el.includes(obj.filteredBy) ? newQuery : el))
      );
    } else {
      let newQuery = exist.replace(obj.id + ",", "");
      setQueries(
        queries.map((el: any) => (el.includes(obj.filteredBy) ? newQuery : el))
      );
    }
  };
interface PaginationData {
  current_page: number;
  last_page: number;
  total: number;
  per_page: number;
}
interface ProductData {
  id: number;
  name: string;
  fabric_type: string;
  price: number;

  images: Array<{image: string}>;

  is_out?: boolean;
  [key: string]: any; // for other properties
}

  const [dataToMap, setDataToMap] = useState<ProductData[]>([]);

  const [loading, setLoading] = useState(false);

  const [paginationData, setPaginationData] = useState<PaginationData>({
      current_page: 1,
      last_page: 1,
      total: 0,
      per_page: 30
    });
  const fetchData = async (nextPage:any) => {
    if (next_page) {
      dispatch(
        getProductsNextPage(
          next_page.substr(process.env.REACT_APP_URL_LENGTH) +
            "&" +
            queries.join("&")
        )
      );
    }
  };

    const observer = useRef<IntersectionObserver | null>(null);

  const [currentPage, setCurrentPage] = useState(1);
  const lastProductElementRef = useCallback((node) => {
    if (loading) return;
    if (observer.current) observer.current.disconnect();
    
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore) {
        setCurrentPage(prevPage => prevPage + 1);
      }
    });
    
    if (node) observer.current.observe(node);
  }, [loading, hasMore]);

   const handleLoadMore = () => {
    console.log("handleLoadMore called");
    if (loading || !hasMore) return;
    const nextPage = paginationData.current_page + 1;
    fetchData(nextPage);
  };
  
  
  // Filter/Param change effect -> Reset list
  useEffect(() => {
    setDataToMap([]);
    setCurrentPage(1);
    sethasMore(true);
    // Trigger initial fetch logic is handled because currentPage becomes 1, but we need to ensure not to duplicate calls if page was already 1.
    // However, since we cleared data, we definitely want to fetch.
    // One nuance with useEffect deps: if currentPage was 1, setting to 1 won't trigger the "fetch on page change" effect.
    // So we manually call fetch here for page 1.
    fetchProducts(1, true); 
  }, [
    location.pathname, 
    min_price, max_price, 
    min_elasticity, max_elasticity, 
    min_weight, max_weight,
    queries
  ]);

  // Fetch on page change (except initial reset which is handled above)
  useEffect(() => {
    if (currentPage > 1) {
      fetchProducts(currentPage, false);
    }
  }, [currentPage]);

  const fetchProducts = (page: number, reset: boolean = false) => {
    setLoading(true);
    let token = localStorage.getItem("token");

    // Construct Params
    const paramsObj: { [key: string]: string | number } = {
      page,
      limit: 30,
    };

    queries.forEach(q => {
        const [key, val] = q.split("=");
        if(key && val) paramsObj[key] = val;
    });

    if (min_price && min_price !== 0) paramsObj.min_price = min_price;
    if (max_price && max_price !== 1000) paramsObj.max_price = max_price;
    if (min_elasticity && min_elasticity !== 0) paramsObj.elasticity_min = min_elasticity;
    if (max_elasticity && max_elasticity !== 100) paramsObj.elasticity_max = max_elasticity;
    if (min_weight && min_weight !== 0) paramsObj.weight_min = min_weight;
    if (max_weight && max_weight !== 1000) paramsObj.weight_max = max_weight;


    axiosInstance({
      method: "get",
      url: '/products',
      params: paramsObj,
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      const { data, current_page, last_page, total, per_page } = response.data;
      
      if (data && data.length > 0) {
        if (reset) {
          setDataToMap(data);
        } else {
          // Filter out duplicates based on product ID
          setDataToMap(prev => {
            const existingIds = new Set(prev.map((p: any) => p.id));
            const newProducts = data.filter((p: any) => !existingIds.has(p.id));
            return [...prev, ...newProducts];
          });
        }
        
        setPaginationData({
          current_page,
          last_page,
          total,
          per_page
        });
        
        sethasMore(current_page < last_page);
      } else {
        if (reset) setDataToMap([]);
        sethasMore(false);
      }
      setLoading(false);
    }).catch(err => {
      console.error("Fetch products error", err);
      setLoading(false);
    });
  };



  return (
    <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
      <Head title="Products" />
      <div className="products_page_container_product ">
        {/*   <div
          className={`bread_crumb_list_products`}
          style={{
            padding: width < 1000 ? "0 20px" : "0 60px",
            borderBottom: width < 1000 ? "1px solid #e0e0e0" : "none",
          }}
        >
          {width < 1000 && (
            <img
              src={backArrow}
              alt="back arrow"
              className={`${width < 1000 ? "mr-auto" : undefined}`}
              onClick={() => history.back()}
            />
          )}
          <span className={`${width < 1000 ? "mr-auto" : undefined}`}>
            {pathnames.map((el: any, i: number) => {
              const routeTo = `${pathnames
                .slice(0, i + 1)
                .join("/")
                .toLowerCase()} `;
              return i === pathnames.length - 1 ? (
                <span key={i} className="bread_crumb_item">
                  {el}
                </span>
              ) : el !== "Women" &&
                el !== "Men" &&
                el !== "Unisex" &&
                el !== "Kids" &&
                el !== "Collection" ? (
                <span
                  key={i}
                  className="bread_crumb_item"
                  onClick={() => dispatch(handleLeftDrawer())}
                >
                  {el}/
                </span>
              ) : (
                <Link key={i} className="bread_crumb_item" to={`/${routeTo}`}>
                  {el}
                  <span style={{ color: "black" }}>/</span>
                </Link>
              );
            })}
          </span>
        </div>*/}

        <div className={`container-fluid products_page product_margin_top`}>
          {width >= 1000 && (
            <div className="filter_collection">
              <Filter
                setMax_elasticity_before={setMax_elasticity_before}
                setMin_elasticity_before={setMin_elasticity_before}
                max_elasticity_before={max_elasticity_before}
                min_elasticity_before={min_elasticity_before}
                isDragging={isDragging}
                fabric={params.fabric}
                categoryId={params.categoryId}
                genderId={params.genderId}
                handleChangePrice={handleChangePrice}
                min_price={min_price}
                max_price={max_price}
                urlProp={url}
                setUrl={setUrl}
                queries={queries}
                addQuery={addQuery}
                min_price_allowed={min_price_allowed}
                max_price_allowed={max_price_allowed}
                setMax_price={setMax_price}
                setMin_price={setMin_price}
                setMax_price_allowed={setMax_price_allowed}
                setMin_price_allowed={setMin_price_allowed}
                handleChangePriceAfter={handleChangePriceAfter}
                max_priceBefore={max_priceBefore}
                min_priceBefore={min_priceBefore}
                max_elasticity={max_elasticity}
                min_elasticity={min_elasticity}
                handleChangeElasticity={handleChangeElasticity}
                setMax_weight_before={setMax_weight_before}
                setMin_weight_before={setMin_weight_before}
                max_weight_before={max_weight_before}
                min_weight_before={min_weight_before}
                max_weight={max_weight}
                min_weight={min_weight}
                handleChangeWeight={handleChangeWeight}
              />
            </div>
          )}
          <div className="products_list_collection">
            <div className="filter_tags_wrapper mt-3">
              <div style={{ width: "90%" }}>
                {width >= 1000 ? (
                  ((filters &&
                    filters.filter((el: any) => el.filteredBy !== "genders")
                      .length > 0) ||
                    max_price_allowed !== max_price ||
                    min_price_allowed !== min_price ||
                    max_elasticity !== max_elasticity_allowed ||
                    min_elasticity !== min_elasticity_allowed ||
                    max_weight !== max_weight_allowed ||
                    min_weight !== min_weight_allowed) && (
                    <p>Selected Filters:</p>
                  )
                ) : (
                  <button
                    className="filter_product_button"
                    onClick={() => setOpenFilterDrawer(true)}
                  >
                    <FilterOutlined className="mr-2" /> Filter
                  </button>
                )}
                {/* FILTER DRAWER */}
                <Drawer
                  title="FILTER"
                  placement={"left"}
                  closable={true}
                  onClose={() => setOpenFilterDrawer(false)}
                  visible={openFilterDrawer}
                  key={"left"}
                  style={{
                    width: "100%",
                    display: openFilterDrawer ? "unset" : "none",
                  }}
                >
                  <div className="p-3">
                    <Filter
                      handleChangeElasticity={handleChangeElasticity}
                      setMax_elasticity_before={setMax_elasticity_before}
                      setMin_elasticity_before={setMin_elasticity_before}
                      max_elasticity_before={max_elasticity_before}
                      min_elasticity_before={min_elasticity_before}
                      isDragging={isDragging}
                      fabric={params.fabric}
                      categoryId={params.categoryId}
                      genderId={params.genderId}
                      handleChangePrice={handleChangePrice}
                      min_price={min_price}
                      max_price={max_price}
                      urlProp={url}
                      setUrl={setUrl}
                      queries={queries}
                      addQuery={addQuery}
                      min_price_allowed={min_price_allowed}
                      max_price_allowed={max_price_allowed}
                      handleChangePriceAfter={handleChangePriceAfter}
                      max_priceBefore={max_priceBefore}
                      min_priceBefore={min_priceBefore}
                      max_elasticity={max_elasticity}
                      min_elasticity={min_elasticity}
                      setMax_weight_before={setMax_weight_before}
                      setMin_weight_before={setMin_weight_before}
                      max_weight_before={max_weight_before}
                      min_weight_before={min_weight_before}
                      max_weight={max_weight}
                      min_weight={min_weight}
                      handleChangeWeight={handleChangeWeight}
                    />
                  </div>
                </Drawer>
                <div className="filter_tags">
                  {/* {((filters && filters.length > 0) ||
                    max_price_allowed !== max_price ||
                    min_price_allowed !== min_price ||
                    max_elasticity !== 100 ||
                    min_elasticity !== 0) && (
                    <div
                      className="filter_tag"
                      onClick={() => {
                        setMax_price(prices.max_price);
                        setMin_price(prices.min_price);
                        setMin_priceBefore(prices.min_price);
                        setMax_priceBefore(prices.max_price);
                        setMax_elasticity(100);
                        setMin_elasticity(0);
                        setMax_elasticity_before(100);
                        setMin_elasticity_before(0);
                        dispatch(clearAllFilters());
                        setQueries([]);
                      }}
                      style={{
                        cursor: "pointer",
                        backgroundColor: "rgba(255, 0, 69, 0.1)",
                        border: "2px solid rgba(255, 0, 69, 0.4)",
                        boxSizing: "border-box",
                        padding: "8px 13px",
                      }}
                    >
                      <p>Clear filters</p>
                      <span>
                        <ClearOutlined
                          style={{ transform: "translateY(-3px)" }}
                        />
                      </span>
                    </div>
                  )} */}
                  {(max_price_allowed !== max_price ||
                    min_price_allowed !== min_price) && (
                    <div className="filter_tag">
                      <p> Price : {`${min_price} - ${max_price}`}</p>
                      <span
                        onClick={() => {
                          setMax_price(prices.max_price);
                          setMin_price(prices.min_price);
                          setMin_priceBefore(prices.min_price);
                          setMax_priceBefore(prices.max_price);
                        }}
                      >
                        X
                      </span>
                    </div>
                  )}
                  {(max_elasticity !== max_elasticity_allowed ||
                    min_elasticity !== min_elasticity_allowed) && (
                    <div className="filter_tag">
                      <p>
                        {" "}
                        Elasticity : {`${min_elasticity} - ${max_elasticity}`}
                      </p>
                      <span
                        onClick={() => {
                          setMax_elasticity(
                            elasticity_fabric.max_elasticity_value
                          );
                          setMin_elasticity(
                            elasticity_fabric.min_elasticity_value
                          );
                          setMax_elasticity_before(
                            elasticity_fabric.max_elasticity_value
                          );
                          setMin_elasticity_before(
                            elasticity_fabric.min_elasticity_value
                          );
                        }}
                      >
                        X
                      </span>
                    </div>
                  )}

                  {(max_weight !== max_weight_allowed ||
                    min_weight !== min_weight_allowed) && (
                    <div className="filter_tag">
                      <p>Weight : {`${min_weight} - ${max_weight}`}</p>
                      <span
                        onClick={() => {
                          setMax_weight(weight_fabric.max_weight_value);
                          setMin_weight(weight_fabric.min_weight_value);
                          setMax_weight_before(weight_fabric.max_weight_value);
                          setMin_weight_before(weight_fabric.min_weight_value);
                        }}
                      >
                        X
                      </span>
                    </div>
                  )}
                  {filters &&
                    filters.map(
                      (el: any, i: number) =>
                        !(
                          el.filteredBy === "genders" &&
                          location.pathname.includes("/product")
                        ) && (
                          <div className="filter_tag" key={i}>
                            <p>{el.name}</p>
                            <span
                              onClick={() => {
                                deleteFilterTag(el);
                                dispatch(deleteFilter(el.name));
                              }}
                            >
                              X
                            </span>
                          </div>
                        )
                    )}
                </div>
              </div>
              {/* <p  className="num_items ml-2">{products && products.length} ITEMS</p> */}
            </div>
          {loading && currentPage === 1 ? (
               <div className="row" style={{ gap: "2.2rem" }}>
                  {Array.from({ length: 10 }).map((_, i) => (
                    <div className="col-12 col-md-2" key={i}>
                       <Card loading bordered={false} style={{ width: "100%" }} />
                    </div>
                  ))}
               </div>
            ) : dataToMap && dataToMap.length > 0 ? (
              <>
              {console.log(dataToMap)}
              <Droppable
                droppableId={`products-list-droppable`}
                direction="horizontal"
                key="products-list-droppable"
              >
                {(provided, snapshot) => (
                    <div
                      className="products-grid"
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                    >
                      {dataToMap.map((product: any, index: number) => {
                          // If it's the last element, attach the ref
                          if (dataToMap.length === index + 1) {
                              return (
                                <div ref={lastProductElementRef} key={`prod-container-${product.id}`}>
                                    <ExampleProductCard
                                        key={`prod-${product.id}`}
                                        index={index}
                                        productPage={true}
                                        product={product}
                                        foryou={forYouCompany}
                                        company={company}
                                        clients={clients}
                                        onClick={openQuickView}
                                        item={{
                                        main: product.images && product.images[0]
                                            ? product.images[0].path
                                            : "",
                                        onHover: product.images && product.images[1]
                                            ? product.images[1].path
                                            : "",
                                        }}
                                    />
                                </div>
                              );
                          } else {
                              return (
                                <ExampleProductCard
                                    key={`prod-${product.id}`}
                                    index={index}
                                    productPage={true}
                                    product={product}
                                    foryou={forYouCompany}
                                    company={company}
                                    clients={clients}
                                    onClick={openQuickView}
                                    item={{
                                    main: product.images && product.images[0]
                                        ? product.images[0].path
                                        : "",
                                    onHover: product.images && product.images[1]
                                        ? product.images[1].path
                                        : "",
                                    }}
                                />
                              );
                          }
                      })}
                      {provided.placeholder}
                    </div>
                )}
              </Droppable>
              {loading && currentPage > 1 && (
                  <div className="text-center py-4 w-100">
                    <Spinner />
                  </div>
              )}
              {!hasMore && dataToMap.length > 0 && (
                   <div className="text-center py-4 w-100">
                      No more products
                   </div>
              )}
              </>
            ) : (
              <div className="unavailable_products_container">
                 <h3 className="unavailable_products">
                    No products available with the selected filters !
                 </h3>
              </div>
            )}

            {/*    {!isLoading && next_page && (
              <div style={{ textAlign: "center" }} className="mb-5 mt-4">
                <button
                  className="load_more_btn"
                  onClick={() => {
                    getNextPageProducts();
                  }}
                >
                  LOAD MORE
                  {isLoadingNext}
                </button>
                {isLoadingNext && <Spinner />}
              </div>
            )} */}
            <Drawer
              title="Product Details"
              placement={width > 768 ? "right" : "bottom"} // Bottom drawer on mobile fits better usually, or full width right
              width={width > 768 ? 720 : "100%"}
              height={width > 768 ? "100%" : "85vh"} // If placement is bottom
              onClose={() => setQuickViewVisible(false)}
              visible={quickViewVisible}
              bodyStyle={{ padding: 0 }}
            >
              {quickViewProduct && (
                <div className="product_details_contanier" style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                  <div className="product_details_infos_scroll" style={{ border: "none", flex: 1, overflowY: "auto" }}>
                    <div className="product_details_infos" style={{ height: "auto", overflow: "visible" }}>
                      <div className="component_details">
                        {quickViewProduct.fabric_type === "denim" && (
                          <DenimProduct
                            key="denim_main"
                            oneProduct={quickViewProduct}
                            editMode={false}
                            setEditMode={() => {}}
                          />
                        )}
                        {(quickViewProduct.fabric_type === "knit" || quickViewProduct.fabric_type === "home_textile") && (
                          <KnitProduct
                            key="knit_main"
                            oneProduct={quickViewProduct}
                            editMode={false}
                            setEditMode={() => {}}
                          />
                        )}
                        {quickViewProduct.fabric_type === "mix" && (
                          <MixProduct
                            key="mix_main"
                            oneProduct={quickViewProduct}
                            editMode={false}
                            setEditMode={() => {}}
                          />
                        )}

                        {!["denim", "knit", "mix"].includes(quickViewProduct.fabric_type) && quickViewProduct.fabric_types && (
                            <div key="alternate_view">
                               {quickViewProduct.fabric_types.name?.toLowerCase() === "denim" && <DenimProduct key="denim_alt" oneProduct={quickViewProduct} editMode={false} setEditMode={() => {}} />}
                               {quickViewProduct.fabric_types.name?.toLowerCase() === "knit" && <KnitProduct key="knit_alt" oneProduct={quickViewProduct} editMode={false} setEditMode={() => {}} />}
                               {quickViewProduct.fabric_types.name?.toLowerCase() === "mix" && <MixProduct key="mix_alt" oneProduct={quickViewProduct} editMode={false} setEditMode={() => {}} />}
                            </div>
                        )}
                      </div>

                      {folders && folders.folders && folders.folders.length > 0 && (
                      <div  style={{ position: "relative", padding: "20px", background: "#fff", height: "auto", minHeight: "400px" }}>
                   
                          {showCollectionForm ? (
                              <div className="create_collection_form_modern" style={{ 
                                  padding: "24px", 
                                  borderRadius: "16px",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "20px"
                              }}>
                                  <h3 style={{ fontSize: "18px", fontWeight: 700, color: "#1e293b", margin: 0 }}>New Collection</h3>
                                  
                                  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                      <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Name</label>
                                      <input
                                          type="text"
                                          placeholder="e.g. Summer 2027"
                                          value={folderData.name}
                                          onChange={(e) => setFolderData({ ...folderData, name: e.target.value })}
                                          style={{ 
                                              border: "1px solid #e2e8f0", 
                                              borderRadius: "8px", 
                                              width: "100%", 
                                              outline: "none", 
                                              fontSize: "14px", 
                                              padding: "10px 14px",
                                              background: "white",
                                              transition: "border-color 0.2s"
                                          }}
                                          onFocus={(e) => e.target.style.borderColor = "#00468c"}
                                          onBlur={(e) => e.target.style.borderColor = "#e2e8f0"}
                                      />
                                  </div>

                                  <div style={{ display: "flex", gap: "16px" }}>
                                      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                                          <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Season</label>
                                          <ReactSelect
                                              placeholder="Select Season"
                                              options={options_season}
                                              value={options_season.find(o => o.value === folderData.season)}
                                              onChange={(val: any) => setFolderData({ ...folderData, season: val.value })}
                                              styles={customStylesCreateModern}
                                          />
                                      </div>
                                      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                                          <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Year</label>
                                          <ReactSelect
                                              placeholder="Select Year"
                                              options={options_year}
                                              value={options_year.find(o => o.value === folderData.year)}
                                              onChange={(val: any) => setFolderData({ ...folderData, year: val.value })}
                                              styles={customStylesCreateModern}
                                          />
                                      </div>
                                  </div>

                                  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                      <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Collaborators</label>
                                      <ReactSelect
                                          isMulti
                                          placeholder="Search names..."
                                          options={collaborators?.map((c: any) => ({ label: c.name, value: c.id }))}
                                          onChange={(val: any) => setFolderData({ ...folderData, collaborator: val.map((v: any) => v.value) })}
                                          styles={customStylesCreateModern}
                                      />
                                  </div>

                                  <div className="buttons_grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginTop: "8px" }}>
                                      <button 
                                          className="btn_modern_cancel"
                                          onClick={() => setShowCollectionForm(false)}
                                          style={{
                                              padding: "12px",
                                              borderRadius: "10px",
                                              border: "1px solid #e1e8f0",
                                              background: "white",
                                              fontSize: "14px",
                                              fontWeight: 600,
                                              cursor: "pointer",
                                              transition: "all 0.2s"
                                          }}
                                          onMouseOver={(e) => e.currentTarget.style.background = "#f8fafc"}
                                          onMouseOut={(e) => e.currentTarget.style.background = "white"}
                                      >
                                          Cancel
                                      </button>
                                      <button 
                                          className="btn_modern_confirm"
                                          onClick={handleCreateNewFolder}
                                          style={{
                                              padding: "12px",
                                              borderRadius: "10px",
                                              border: "none",
                                              background: "#00468c",
                                              color: "white",
                                              fontSize: "14px",
                                              fontWeight: 600,
                                              cursor: "pointer",
                                              transition: "all 0.2s"
                                          }}
                                          onMouseOver={(e) => e.currentTarget.style.opacity = "0.9"}
                                          onMouseOut={(e) => e.currentTarget.style.opacity = "1"}
                                      >
                                          Create
                                      </button>
                                  </div>
                              </div>
                          ) : (
                              <>
                                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                                      <span style={{ fontSize: "14px", fontWeight: 600, color: "#64748b" }}>Choose a collection</span>
                                      <Tooltip title="Create New Collection">
                                          <button
                                              onClick={() => setShowCollectionForm(true)}
                                              style={{ 
                                                  width: "36px", 
                                                  height: "36px", 
                                                  borderRadius: "50%", 
                                                  border: "1px solid #e1e8f0", 
                                                  background: "white",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  cursor: "pointer",
                                                  color: "#00468c",
                                                  transition: "all 0.2s"
                                              }}
                                              onMouseOver={(e) => e.currentTarget.style.background = "#f1f5f9"}
                                              onMouseOut={(e) => e.currentTarget.style.background = "white"}
                                          >
                                              <PlusIcon />
                                          </button>
                                      </Tooltip>
                                  </div>

                                  <div className="list_folders" style={{ display: "grid", gridTemplateColumns:"repeat(2,1fr)", gap: "8px", maxHeight: "300px", overflowY: "auto", padding: "10px" }}>
                                      {folders.folders &&
                                          folders.folders
                                              .filter((el: any) => el.client_id == user.id)
                                              .map((folder: any) => (
                                                  <Folder
                                                      clickable={true}
                                                      selectOneFolder={true}
                                                      addToCollection={true}
                                                      folder={folder}
                                                      key={folder.id}
                                                  />
                                              ))}
                                  </div>

                                  <div className="buttons_grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginTop: "20px" }}>
                                    
                                      <button 
                                          className="btn_modern_confirm"
                                          onClick={() => {
                                              if (folders.folderIdToMoveTo) {
                                                  dispatch(addProducttoFolder(folders.folderIdToMoveTo, quickViewProduct?.id));
                                                  dispatch(clearfolderToMoveTo());
                                              } else {
                                                  message.error("Please select a collection first");
                                              }
                                          }}
                                          style={{
                                              padding: "8px",
                                              borderRadius: "8px",
                                              border: "none",
                                              background: "#00468c",
                                              color: "white",
                                              fontSize: "13px",
                                              fontWeight: 600,
                                              cursor: "pointer"
                                          }}
                                      >
                                          Confirm
                                      </button>
                                  </div>
                              </>
                          )}


                      </div>)}

                    </div>
                  </div>
                  <div style={{ padding: "10px 30px 20px" }}>
                    <Link
                      to={`/product/details/${params.fabric}/${params.genderId}/${params.categoryId}/${quickViewProduct.name}/${quickViewProduct.id}`}
                      className="ant-btn ant-btn-primary ant-btn-block"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "50px",
                        fontSize: "16px",
                        borderRadius: "4px",
                        backgroundColor: "#000",
                        borderColor: "#000",
                        fontWeight: "bold",
                        textTransform: "uppercase"
                      }}
                    >
                      VIEW FULL DETAILS
                    </Link>
                  </div>
                </div>
                )}
            </Drawer>
            <BottomDrawer mode="add_to_collection" />
          </div>
        </div>
      </div>
    </DragDropContext>
  );
};
